import { type Writable, writable } from 'svelte/store';
import type { PointsInfoBannerContent } from '../domain/points-info-banner/PointsInfoBannerContent.ts';
import type { PointsInfoBannerType } from '../domain/points-info-banner/PointsInfoBannerType.ts';

export const pointsInfoBannerContextStore: Writable<Map<string, {
	pointsInfoBannerContent: PointsInfoBannerContent,
	pointsInfoBannerType: PointsInfoBannerType
}>> = writable(new Map<string, { pointsInfoBannerContent: PointsInfoBannerContent; pointsInfoBannerType: PointsInfoBannerType }>([]));

export const addElementToPointsInfoBannerContextStore = (url: string, context: { pointsInfoBannerContent: PointsInfoBannerContent, pointsInfoBannerType: PointsInfoBannerType }) => {
	pointsInfoBannerContextStore.update((contextStore) => {
		contextStore.set(url, context);
		return contextStore;
	});
};